export function isEditorUiNode(node) {
	if (!node || typeof node.closest !== "function") return false;
	return !!node.closest("[data-er-editor-ui]");
}

export function getTextEditRoot() {
	const active = document.activeElement;
	if (active?.getAttribute?.("data-er-text-edit") === "1") return active;
	return document.querySelector('[data-er-text-edit="1"]');
}

export function saveTextSelection() {
	try {
		const sel = window.getSelection();
		if (!sel || sel.rangeCount === 0) return null;
		const range = sel.getRangeAt(0);
		const root = getTextEditRoot();
		if (!root || !root.contains(range.commonAncestorContainer)) return null;
		return range.cloneRange();
	} catch (_) {
		return null;
	}
}

export function restoreTextSelection(savedRange) {
	if (!savedRange) return false;
	try {
		const sel = window.getSelection();
		if (!sel) return false;
		sel.removeAllRanges();
		sel.addRange(savedRange);
		return true;
	} catch (_) {
		return false;
	}
}

export function applyTextColorToElement(element, color, savedRange, onUpdate) {
	const root = getTextEditRoot();
	const s = element?.style || {};

	if (root && savedRange) {
		restoreTextSelection(savedRange);
		root.focus();
		const sel = window.getSelection();
		const hasSelection = sel && sel.rangeCount > 0 && !sel.isCollapsed;
		if (hasSelection) {
			try {
				document.execCommand("styleWithCSS", false, true);
				document.execCommand("foreColor", false, color);
			} catch (_) {
				try {
					document.execCommand("foreColor", false, color);
				} catch (_2) {
					/* ignore */
				}
			}
			onUpdate({ ...element, content: { ...element.content, html: root.innerHTML } });
			return;
		}
	}

	onUpdate({ ...element, style: { ...s, color } });
}
